// ============================================================
// EcomChief Bundle Builder — Product Data Config
// Version: 2.0.0 — Handles verified against Shopify CSV export
//
// HOW TO ADD A NEW PRODUCT:
// 1. Copy any existing product block below
// 2. Update id, name, shortName, category, price, handle, bullets
// 3. Save file and re-upload to Shopify theme assets
//
// HOW CHECKOUT WORKS (no Variant IDs needed):
// The builder fetches each product's default variant by handle
// via Shopify's /products/{handle}.js endpoint at checkout time.
// ============================================================

const ECOMCHIEF_PRODUCTS = [

  // ─── DROPSHIPPING ────────────────────────────────────────
  {
    id: "ds-001",
    name: "Pet Supplies Store",
    shortName: "Pet Supplies",
    category: "dropshipping",
    price: 99,
    handle: "pet-supplies-dropshipping-business-for-sale",
    bullets: ["Fully stocked catalog", "Supplier connected", "No inventory needed"]
  },
  {
    id: "ds-002",
    name: "Electronics Store",
    shortName: "Electronics",
    category: "dropshipping",
    price: 99,
    handle: "electronics-dropshipping-business-for-sale",
    bullets: ["Tech niche", "Trending products", "Ready to launch"]
  },
  {
    id: "ds-003",
    name: "Auto Accessories Store",
    shortName: "Auto Accessories",
    category: "dropshipping",
    price: 99,
    handle: "auto-accessories-dropshipping-business",
    bullets: ["High-margin niche", "Supplier network", "SEO-ready"]
  },
  {
    id: "ds-004",
    name: "Women's Fashion Store",
    shortName: "Women's Fashion",
    category: "dropshipping",
    price: 99,
    handle: "womens-fashion-dropshipping-business-for-sale",
    bullets: ["Boutique brand", "Social-ready", "Full product range"]
  },
  {
    id: "ds-005",
    name: "Fitness & Gym Store",
    shortName: "Fitness & Gym",
    category: "dropshipping",
    price: 99,
    handle: "fitness-dropshipping-business-for-sale",
    bullets: ["Growing niche", "Workout gear", "Supplier ready"]
  },
  {
    id: "ds-006",
    name: "Health Supplements Store",
    shortName: "Health Supps",
    category: "dropshipping",
    price: 99,
    handle: "health-supplements-dropshipping-business",
    bullets: ["High AOV niche", "Repeat buyers", "Premium positioning"]
  },
  {
    id: "ds-007",
    name: "Dollar Discount Store",
    shortName: "Dollar Discount",
    category: "dropshipping",
    price: 99,
    handle: "dollar-discount-dropshipping-business",
    bullets: ["Mass market appeal", "High volume", "Broad catalog"]
  },
  {
    id: "ds-008",
    name: "Men's Grooming Store",
    shortName: "Men's Grooming",
    category: "dropshipping",
    price: 99,
    handle: "mens-grooming-dropshipping-business",
    bullets: ["Fast-growing niche", "Loyal customers", "Brand-ready"]
  },
  {
    id: "ds-009",
    name: "Beauty & Makeup Store",
    shortName: "Beauty & Makeup",
    category: "dropshipping",
    price: 99,
    handle: "beauty-makeup-dropshipping-business-for-sale",
    bullets: ["Cosmetics niche", "Viral potential", "Influencer-friendly"]
  },
  {
    id: "ds-010",
    name: "Home & Garden Store",
    shortName: "Home & Garden",
    category: "dropshipping",
    price: 99,
    handle: "home-garden-dropshipping-business-for-sale",
    bullets: ["Evergreen niche", "Wide catalog", "High repeat rate"]
  },
  {
    id: "ds-011",
    name: "Women's Swimwear Store",
    shortName: "Swimwear",
    category: "dropshipping",
    price: 99,
    handle: "womens-swimwear-dropshipping-business",
    bullets: ["Seasonal spikes", "Visual niche", "Social ads ready"]
  },
  {
    id: "ds-012",
    name: "Medical Supplies Store",
    shortName: "Medical Supplies",
    category: "dropshipping",
    price: 99,
    handle: "medical-supplies-dropshipping-business",
    bullets: ["Healthcare niche", "Steady demand", "B2B potential"]
  },
  {
    id: "ds-013",
    name: "Organic Wellness Store",
    shortName: "Organic Wellness",
    category: "dropshipping",
    price: 99,
    handle: "buy-premium-organic-food-health-beauty-store",
    bullets: ["Premium pricing", "Health-conscious buyers", "Subscription potential"]
  },
  {
    id: "ds-014",
    name: "Sunglass & Watch Store",
    shortName: "Sunglasses+Watches",
    category: "dropshipping",
    price: 99,
    handle: "wooden-sunglasses-watches-dropshipping-store",
    bullets: ["Fashion accessories", "Gift market", "High margins"]
  },
  {
    id: "ds-015",
    name: "Specialty Coffee Store",
    shortName: "Specialty Coffee",
    category: "dropshipping",
    price: 99,
    handle: "specialty-coffee-dropshipping-business",
    bullets: ["Subscription niche", "Passionate buyers", "Brand building"]
  },
  {
    id: "ds-016",
    name: "Kids Fashion Store",
    shortName: "Kids Fashion",
    category: "dropshipping",
    price: 99,
    handle: "kids-fashion-dropshipping-business-for-sale",
    bullets: ["Parent buyers", "Gift occasions", "Repeat purchases"]
  },
  {
    id: "ds-017",
    name: "Home Decor & Furniture Store",
    shortName: "Home Decor",
    category: "dropshipping",
    price: 99,
    handle: "buy-home-decor-store-1",
    bullets: ["High AOV", "Pinterest traffic", "Interior design niche"]
  },
  {
    id: "ds-018",
    name: "Men's Lifestyle Store",
    shortName: "Men's Lifestyle",
    category: "dropshipping",
    price: 99,
    handle: "mens-lifestyle-dropshipping-business",
    bullets: ["Broad male niche", "Multiple categories", "Strong ad angles"]
  },
  {
    id: "ds-019",
    name: "Jewelry & Accessories Store",
    shortName: "Jewelry",
    category: "dropshipping",
    price: 99,
    handle: "jewelry-dropshipping-business-for-sale",
    bullets: ["Gift market", "High margins", "Evergreen demand"]
  },
  {
    id: "ds-020",
    name: "Leggings & Activewear Store",
    shortName: "Activewear",
    category: "dropshipping",
    price: 99,
    handle: "leggings-dropshipping-business-for-sale",
    bullets: ["Fitness lifestyle", "TikTok friendly", "Repeat buyers"]
  },
  {
    id: "ds-021",
    name: "Travel Accessories Store",
    shortName: "Travel Accessories",
    category: "dropshipping",
    price: 99,
    handle: "travel-accessories-dropshipping-business",
    bullets: ["Travel niche", "Gift market", "Seasonal upside"]
  },
  {
    id: "ds-022",
    name: "Backpack & Travel Bags Store",
    shortName: "Travel Bags",
    category: "dropshipping",
    price: 99,
    handle: "backpack-dropshipping-business-for-sale",
    bullets: ["Student & traveller market", "Back-to-school spikes", "High volume"]
  },
  {
    id: "ds-023",
    name: "Video Gaming Store",
    shortName: "Video Gaming",
    category: "dropshipping",
    price: 99,
    handle: "video-gaming-dropshipping-business",
    bullets: ["Passionate niche", "Accessories + merch", "Year-round demand"]
  },
  {
    id: "ds-024",
    name: "Perfume & Cosmetics Store",
    shortName: "Perfume Store",
    category: "dropshipping",
    price: 99,
    handle: "perfume-cosmetics-dropshipping-business",
    bullets: ["Luxury feel", "Gift buyers", "High repeat rate"]
  },
  {
    id: "ds-025",
    name: "Handbag & Accessories Store",
    shortName: "Handbags",
    category: "dropshipping",
    price: 99,
    handle: "handbag-dropshipping-business-for-sale",
    bullets: ["Women's fashion", "Gift market", "High margins"]
  },
  {
    id: "ds-026",
    name: "Urban Streetwear Store",
    shortName: "Streetwear",
    category: "dropshipping",
    price: 250,
    handle: "streetwear-dropshipping-business-for-sale",
    bullets: ["Youth culture niche", "Strong brand identity", "Social media ready"]
  },
  {
    id: "ds-027",
    name: "Camping & Outdoor Gear Store",
    shortName: "Camping & Outdoor",
    category: "dropshipping",
    price: 99,
    handle: "outdoor-camping-dropshipping-business",
    bullets: ["Outdoor enthusiasts", "High AOV", "Seasonal peaks"]
  },
  {
    id: "ds-028",
    name: "Watches & Accessories Store",
    shortName: "Watches",
    category: "dropshipping",
    price: 99,
    handle: "watches-sunglasses-dropshipping-business",
    bullets: ["Luxury positioning", "Gift market", "High margins"]
  },
  {
    id: "ds-029",
    name: "Lingerie & Intimates Store",
    shortName: "Lingerie",
    category: "dropshipping",
    price: 99,
    handle: "lingerie-dropshipping-business-for-sale",
    bullets: ["Recurring buyers", "Gift occasions", "Strong AOV"]
  },
  {
    id: "ds-030",
    name: "Men's Shoes Store",
    shortName: "Men's Shoes",
    category: "dropshipping",
    price: 99,
    handle: "mens-shoes-dropshipping-business-for-sale",
    bullets: ["Fashion footwear", "Broad appeal", "High search volume"]
  },
  {
    id: "ds-031",
    name: "Men's Fashion Store",
    shortName: "Men's Fashion",
    category: "dropshipping",
    price: 99,
    handle: "mens-fashion-dropshipping-business-for-sale",
    bullets: ["Full menswear range", "Influencer-friendly", "Strong margins"]
  },
  {
    id: "ds-032",
    name: "Gadgets Store",
    shortName: "Gadgets",
    category: "dropshipping",
    price: 99,
    handle: "gadgets-dropshipping-business-for-sale",
    bullets: ["Impulse buys", "Viral product potential", "Gift market"]
  },
  {
    id: "ds-033",
    name: "Hip Hop & Streetwear Store",
    shortName: "Hip Hop Wear",
    category: "dropshipping",
    price: 99,
    handle: "hip-hop-streetwear-dropshipping-business",
    bullets: ["Cultural niche", "Passionate community", "Social-first brand"]
  },
  {
    id: "ds-034",
    name: "Sneakers & Shoes Store",
    shortName: "Sneakers",
    category: "dropshipping",
    price: 99,
    handle: "sneakers-shoes-dropshipping-business-for-sale",
    bullets: ["Sneakerhead culture", "High demand", "Repeat buyers"]
  },

  // ─── AMAZON FBA ──────────────────────────────────────────
  {
    id: "amz-001",
    name: "Amazon Organic Beauty Store",
    shortName: "Organic Beauty",
    category: "amazon",
    price: 99,
    handle: "amazon-organic-health-beauty-fba-business",
    bullets: ["Beauty niche", "Amazon affiliate ready", "Content included"]
  },
  {
    id: "amz-002",
    name: "Amazon Electronics Store",
    shortName: "Amazon Electronics",
    category: "amazon",
    price: 99,
    handle: "amazon-electronics-fba-business",
    bullets: ["High commission products", "Tech reviews ready", "SEO content"]
  },
  {
    id: "amz-003",
    name: "Amazon Pharmacy Store",
    shortName: "Amazon Pharmacy",
    category: "amazon",
    price: 99,
    handle: "buy-amazon-pharmacy-store",
    bullets: ["Health niche", "Steady demand", "Trusted category"]
  },
  {
    id: "amz-004",
    name: "Amazon Health & Fitness Store",
    shortName: "Amazon Health",
    category: "amazon",
    price: 99,
    handle: "amazon-health-fitness-fba-business",
    bullets: ["Evergreen niche", "High volume", "Commission ready"]
  },
  {
    id: "amz-005",
    name: "Amazon Apple Accessories Store",
    shortName: "Apple Accessories",
    category: "amazon",
    price: 99,
    handle: "buy-amazon-apple-accessories-business",
    bullets: ["Apple ecosystem", "Loyal buyers", "High search intent"]
  },
  {
    id: "amz-006",
    name: "Amazon Grocery Store",
    shortName: "Amazon Grocery",
    category: "amazon",
    price: 99,
    handle: "amazon-grocery-fba-business-for-sale",
    bullets: ["Repeat purchases", "Pantry staples", "Subscription potential"]
  },
  {
    id: "amz-007",
    name: "Amazon Pet Store",
    shortName: "Amazon Pets",
    category: "amazon",
    price: 99,
    handle: "amazon-pet-supplies-fba-business",
    bullets: ["Pet owner market", "Loyal niche", "High LTV"]
  },
  {
    id: "amz-008",
    name: "Amazon Toys Store",
    shortName: "Amazon Toys",
    category: "amazon",
    price: 99,
    handle: "buy-amazon-fba-toys-games-store",
    bullets: ["Gift occasions", "Seasonal spikes", "Family market"]
  },
  {
    id: "amz-009",
    name: "Amazon Sneaker Store",
    shortName: "Amazon Sneakers",
    category: "amazon",
    price: 99,
    handle: "buy-amazon-fba-sneakers-footwear-store",
    bullets: ["Footwear niche", "High commissions", "Trend-driven"]
  },
  {
    id: "amz-010",
    name: "Amazon Home Decor Store",
    shortName: "Amazon Home Decor",
    category: "amazon",
    price: 99,
    handle: "amazon-home-decor-furniture-fba-business",
    bullets: ["Interior design niche", "Pinterest traffic", "High AOV"]
  },
  {
    id: "amz-011",
    name: "Amazon Auto Accessories Store",
    shortName: "Amazon Auto",
    category: "amazon",
    price: 99,
    handle: "amazon-auto-accessories-fba-business",
    bullets: ["Car enthusiasts", "High intent buyers", "Broad market"]
  },
  {
    id: "amz-012",
    name: "Amazon Makeup Store",
    shortName: "Amazon Makeup",
    category: "amazon",
    price: 99,
    handle: "buy-amazon-fba-beauty-makeup-store",
    bullets: ["Beauty community", "Tutorial-driven traffic", "Repeat buyers"]
  },
  {
    id: "amz-013",
    name: "Amazon Coffee Store",
    shortName: "Amazon Coffee",
    category: "amazon",
    price: 99,
    handle: "amazon-coffee-fba-business-for-sale",
    bullets: ["Passionate niche", "Subscription buyers", "Daily habit product"]
  },

  // ─── DIGITAL AGENCIES ────────────────────────────────────
  {
    id: "ag-001",
    name: "AI Automation Agency",
    shortName: "AI Automation",
    category: "agency",
    price: 99,
    handle: "ai-agency-business-for-sale",
    bullets: ["AI-powered services", "B2B clients", "Recurring revenue"]
  },
  {
    id: "ag-002",
    name: "Video Production Agency",
    shortName: "Video Production",
    category: "agency",
    price: 99,
    handle: "buy-premium-video-production-agency",
    bullets: ["Done-for-you setup", "Delivery team included", "B2B ready"]
  },
  {
    id: "ag-003",
    name: "Virtual Assistant Agency",
    shortName: "VA Agency",
    category: "agency",
    price: 99,
    handle: "buy-personal-assistant-agency",
    bullets: ["Drop servicing model", "VA network", "Low overhead"]
  },
  {
    id: "ag-004",
    name: "Digital Marketing Agency",
    shortName: "Digital Marketing",
    category: "agency",
    price: 99,
    handle: "digital-marketing-agency-business-for-sale",
    bullets: ["Full-service agency", "Client portal", "Retainer model"]
  },
  {
    id: "ag-005",
    name: "Content Writing Agency",
    shortName: "Content Writing",
    category: "agency",
    price: 99,
    handle: "content-writing-agency-business-for-sale",
    bullets: ["Writer network", "SEO content", "Monthly retainers"]
  },
  {
    id: "ag-006",
    name: "Facebook Ads Agency",
    shortName: "Facebook Ads",
    category: "agency",
    price: 400,
    handle: "facebook-ads-agency-business-for-sale",
    bullets: ["Paid ads expertise", "Client management", "Proven templates"]
  },
  {
    id: "ag-007",
    name: "Web Design Agency",
    shortName: "Web Design",
    category: "agency",
    price: 99,
    handle: "buy-website-design-development-agency",
    bullets: ["Design team ready", "Portfolio included", "Recurring revenue"]
  },
  {
    id: "ag-008",
    name: "Lead Generation Agency",
    shortName: "Lead Generation",
    category: "agency",
    price: 99,
    handle: "lead-generation-agency-business-for-sale",
    bullets: ["High-demand service", "Outreach system", "B2B focused"]
  },
  {
    id: "ag-009",
    name: "SEO Agency",
    shortName: "SEO Agency",
    category: "agency",
    price: 99,
    handle: "seo-agency-business-for-sale",
    bullets: ["Done-for-you SEO", "Client dashboard", "Monthly retainers"]
  },

  // ─── READY-MADE APPS ─────────────────────────────────────
  {
    id: "app-001",
    name: "White-Label Booking App",
    shortName: "Booking App",
    category: "app",
    price: 99,
    handle: "buy-booking-app",
    bullets: ["Full source code", "Resell rights", "SaaS model"]
  },
  {
    id: "app-002",
    name: "White-Label Job Board App",
    shortName: "Job Board App",
    category: "app",
    price: 99,
    handle: "justjobs-whitelabel-job-board-recruitment-platform",
    bullets: ["Recruitment niche", "White-label ready", "Monetizable"]
  },
  {
    id: "app-003",
    name: "Stride — Habit & Goal Tracker",
    shortName: "Habit Tracker",
    category: "app",
    price: 99,
    handle: "stride-whitelabel-habit-goal-tracker-app",
    bullets: ["Productivity niche", "Mobile-ready", "Resell rights"]
  },
  {
    id: "app-004",
    name: "Auto Marketing — AI Marketing App",
    shortName: "AI Marketing App",
    category: "app",
    price: 99,
    handle: "automarketing-white-label-ai-marketing-agent",
    bullets: ["AI-powered", "Marketing automation", "SaaS model"]
  },
  {
    id: "app-005",
    name: "Client Folio — Pocket CRM",
    shortName: "Pocket CRM",
    category: "app",
    price: 99,
    handle: "clientfolio-whitelabel-pocket-crm-for-pros",
    bullets: ["CRM for freelancers", "Client management", "Full source code"]
  },
  {
    id: "app-006",
    name: "QR Hero — QR Code Generator",
    shortName: "QR Code App",
    category: "app",
    price: 99,
    handle: "qr-hero",
    bullets: ["Utility app", "B2B market", "White-label ready"]
  },
  {
    id: "app-007",
    name: "Star Magnet — Review App",
    shortName: "Review App",
    category: "app",
    price: 99,
    handle: "star-magnet-whitelabel-review-reputation-app",
    bullets: ["Local business market", "Reputation mgmt", "Recurring revenue"]
  },
  {
    id: "app-008",
    name: "Invoice Hero — Invoice Generator",
    shortName: "Invoice App",
    category: "app",
    price: 99,
    handle: "invoice-hero-white-label-quick-invoice-generator-app",
    bullets: ["Freelancer tool", "High demand", "Monetizable SaaS"]
  },
  {
    id: "app-009",
    name: "Bio Wise — Link-in-Bio Builder",
    shortName: "Link-in-Bio App",
    category: "app",
    price: 99,
    handle: "bio-wise-link-in-bio-page-builder-app",
    bullets: ["Creator economy", "Social media tool", "Subscription model"]
  },
  {
    id: "app-010",
    name: "Save Wise — Expense Tracker",
    shortName: "Expense Tracker",
    category: "app",
    price: 99,
    handle: "sample-store",
    bullets: ["Finance niche", "Mass market appeal", "Full source code"]
  },
  {
    id: "app-011",
    name: "HeroCV — AI Resume Builder",
    shortName: "AI Resume App",
    category: "app",
    price: 99,
    handle: "herocv-white-label-ai-resume-cover-letter-builder",
    bullets: ["AI-powered", "Job seeker market", "High demand"]
  }

];

// ─── BUNDLE PRICING ──────────────────────────────────────────
// Flat-rate pricing — any combination of businesses
// 1 item  = individual price ($99)
// 2 items = flat $149  (you save up to $49)
// 3+ items = flat $199 (you save up to $98+)
const BUNDLE_PRICING = {
  1: null,   // full price
  2: 149,    // any 2 businesses = $149
  3: 199,    // any 3+ businesses = $199
};

// ─── PROMO CODES ─────────────────────────────────────────────
const PROMO_CODES = {
  "CHIEF10":  10,
  "LAUNCH20": 20,
  "BUNDLE15": 15,
};

// ─── AI AFFINITY MAP ─────────────────────────────────────────
const AFFINITY_MAP = {
  dropshipping: ["agency", "app"],
  amazon:       ["app", "dropshipping"],
  agency:       ["app", "amazon"],
  app:          ["agency", "dropshipping"],
};